import axios from "axios"
import { getToken } from "../helpers/utilities";
export const init = () => {
    const token = getToken()
    console.log(token);
    axios.defaults.headers.get['Content-Type'] = `application/json;charset=UTF-8`;
    axios.defaults.headers.get['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.post['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.put['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.delete['authorization'] = `Bearer ${token}`;
    axios.defaults.headers.patch['authorization'] = `Bearer ${token}`;
}
init()
export const  http = axios 